<template>
    <div class="good_lesson" style="padding-top: 16px;">

        <adModule version="4"/>

        <div class="rob_list">
            <div @click="toDetailByBizType(-1 , item.id)" class="rob_item" v-for="(item , index) in dataList"
                 :key="index">
                <div class="rob_img">
                    <img :src="item.coverImg" alt="">
                </div>
                <div class="rob_content">
                    <div class="item_title">{{item.title}}</div>
                    <div class="rob_state"><span>已更新{{item.updateCount}}节课/共{{item.totalCount}}节课</span></div>
                    <div class="rob_bottom">
                        <div><span class="limit_title"></span><span class="price_title">￥{{item.price}}</span>
                            <del class="del_price">原价￥{{item.lineThroughPrice}}</del>
                        </div>
                        <div class="bottom_span">
                            <span>{{item.learnCount}}人在学</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alignCenter paddingV8" v-show="status == 'loading'">
                <i class="icon spinner-loader"></i>
            </div>

            <div class="paddingV16 alignCenter font14r colorCCC"
                 v-show="status=='ready' && dataList.length < 1">
                暂没有任何内容
            </div>
            <div class="paddingV16 alignCenter font14r colorCCC"
                 v-show="status=='ready' && pagination.current == pagination.totalPage"
                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                没有更多课程了
            </div>

        </div>
    </div>
</template>
<script>
// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '../../appConfig';

// data
import adTypeEnum from '@/components/ad/adTypeEnum';

// modules
import adModule from '@/components/ad/bannerModule4'

import {toDetailByBizType} from '@comp/shixunApp/toDetail';

// utils
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';


const config = {
    apiConfig: {
        list: {
            url: '/portal/courseVod/getNinePointNineVod',
            dataPath: 'data.records',
            totalPath: 'data.total',
            totalPagePath: 'data.pages',
        }
    }
};

export default {
    name: 'goodLesson',
    extends : shixunPagePart,
    components : { adModule },

    data() {
        return {
            pageKey: 'goodcourses-list',
            adTypeEnum : adTypeEnum,
            enableDataList: true,
            autoLoadDataList: true,
            scrollToLoadNextPage: true,
            apiConfig: config.apiConfig,
            toDetailByBizType: toDetailByBizType,
            title: '9.9元好课'
        }
    },
    methods: {
        // setWechatShare: function () {
        //     let wechatShareOptions = {
        //         title: appHelper.getTitle(),
        //         // desc    : this.desc,
        //         link: location.href,
        //         imgUrl: appHelper.getAppIcon() // 分享图标
        //     };
        //     wechatHelper.setShare(wechatShareOptions);
        // }
    },
    mounted() {
        appHelper.setTitle(this.title);

        // if (deviceHelper.isBrowser && browserHelper.isWechat) {
        //     this.setWechatShare();
        // }

    },
}
</script>
<style lang="scss" scoped>
.good_lesson {
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
}

.rob_list {
    width: 100%;
    // padding: 0 0px 18px;
    margin-top: 16px;
    box-sizing: border-box;
}

.rob_item {
    width: 100%;
    height: 78px;
    margin-bottom: 28px;
    display: flex;

    .rob_img {
        width: 124px;
        height: 76px;
        border-radius: 4px;
        margin-right: 8px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            background: #ccc;
            border-radius: 4px;
        }
    }


    .rob_content {
        flex: 1;
        height: 100%;
        overflow: hidden;


    }
}


.item_title {
    height: 18px;

    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    color: #333333;

    // margin-top: 4px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.rob_state {
    font-size: 12px;
    font-weight: 500;
    span {

        color: #999999;

    }

}

.limit_title {

    font-size: 10px;
    font-weight: 500;
    color: #333333;

}

.price_title {

    font-size: 18px;
    font-weight: 500;
    color: #FC3439;

    margin-right: 5px;
}

.del_price {

    font-size: 11px;
    font-weight: 500;
    color: #999999;

    margin-bottom: 5px;
}

.rob_bottom {
    height: 26px;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
}


.rob_btn {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: center;
    .btn_content {
        width: 218px;
        height: 28px;
        border: 1px solid #FF7377;

        border-radius: 4px;
        text-align: center;
        span {
            font-size: 12px;
            font-weight: 500;
            // line-height: 17px;
            color: #FF7377;

        }
    }
}

.bottom_span {

    font-size: 12px;
    font-weight: 500;
    line-height: 30px;
    color: #999999;

}

</style>
